import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { VentanaFlotante } from '../models/VentanaFlotante';
import { TallerCercanoGt } from '../services/glass-talleres.service';

@Component({
  selector: 'ral-busqueda-talleres-gt',
  templateUrl: './busqueda-talleres.component.html',
  styleUrls: ['./busqueda-talleres.component.scss'],
})
export class BusquedaTalleresGtComponent extends VentanaFlotante {
  dataColumns = [
    'nombreTaller',
    'codigoPostal',
    'poblacion',
    'provincia',
    'direccion',
    'latitud',
    'longitud',
  ];
  displayedColumns = ['seleccion', ...this.dataColumns];
  columnLabels: { [key: string]: string } = {
    nombreTaller: 'Nombre taller',
    codigoPostal: 'Código postal',
    poblacion: 'Población',
    provincia: 'Provincia',
    direccion: 'Dirección',
    latitud: 'Latitud',
    longitud: 'Longitud',
  };
  dataSource = new MatTableDataSource<TallerCercanoGt>([]);

  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: any | null,
  ) {
    super(dialogRef, data);
    this.dataSource.data = Array.isArray(data?.listado) ? data.listado : [];
  }

  seleccionarTaller(taller: TallerCercanoGt, event?: Event): void {
    event?.stopPropagation();
    this.dialogRef.close(taller);
  }
}
